module.exports = __webpack_public_path__ + "media/main.090ddba2.mp3";